import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SptRecorderService} from '@spout/global-web/data-access';

@Component({
  selector: 'spt-help-select-microhone-content',
  templateUrl: './help-select-microhone-content.component.html',
  styleUrls: ['./help-select-microhone-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpSelectMicrohoneContentComponent {
  constructor(private _recorder: SptRecorderService) {}
  refresh(): void {
    this._recorder.refreshAudioDeviceList().subscribe(() => {});
  }
}
